<template>
  <a-form-model ref="form" layout="horizontal" :model="model" v-bind="{labelCol: { span: 6 },wrapperCol: { span: 12 },}" :rules="rules">
    <a-form-model-item label='公式描述' prop='description' >
      <a-textarea placeholder='请输入公式描述' :rows="4" v-model='model.description'></a-textarea>
    </a-form-model-item>
    <a-form-model-item label='结果解释'>
      <a-button size='small' @click='addLine' icon="plus">添加</a-button>
      <a-table :columns='columns' :dataSource='dataSource' :pagination='false' rowKey='id' size='small'></a-table>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import { getAction } from '@/api/manage'
export default {
  name: 'Step6',
  components: {  },
  data() {
    return {
      model:{},
      rules: {
        description:[baseRules.required]
      },
      dataSource: [],
      columns: [
        {
          title: '#',
          dataIndex: '',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => index + 1
        },
        {
          title: '结果',
          dataIndex: 'result',
          customRender: (text, record, index) => (<a-input size='small' v-model={record.result} />)
        },
        {
          title: '下限',
          dataIndex: 'minValue',
          customRender: (text, record, index) => (<a-input size='small' v-model={record.minValue} />)
        },
        {
          title: '上限',
          dataIndex: 'maxValue',
          customRender: (text, record, index) => (<a-input size='small' v-model={record.maxValue} />)
        },
        {
          title: '值',
          dataIndex: 'value',
          customRender: (text, record, index) => (<a-input size='small' v-model={record.value} />)
        },
        {
          title: '操作',
          width: 100,
          customRender: (text, record, index) => (<a-button size='small' type='danger' onClick={event => this.handleDelete(record, index)}>删除</a-button>)
        }
      ],
    }
  },
  created() {
  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))
      this.dataSource = []
      if(this.model.id){
        getAction('/project/projectFormulaResult/list',{formulaId:this.model.id}).then(res=>{
          if(res.success){
            this.dataSource = res.result || []
          }
        })
      }


    },
    /**
     * 添加结果解释
     */
    addLine() {
      this.dataSource.push({})
    },
    /**
     * 删除结果解释
     * @param record
     * @param index
     */
    handleDelete(record,index) {
      this.dataSource.splice(index, 1)
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          this.model.resultList = this.dataSource
          result = true
        }
      })
      // return false
      return result
    }
  }


}
</script>

<style scoped>

</style>
